import api from './api';

const userService = {
  /**
   * @param {string} role e.g. "PM"
   * @param {string} [projectCode] when set, only users with UserRoleProjectSiteMapping for this project (code or nProjectNo)
   * @param {number|string} [siteNo] when set, project-wide PM (null site on mapping) or PM mapped to this site (SiteNo)
   */
  async getByRole(role, projectCode, siteNo) {
    const params = {};
    if (projectCode != null && String(projectCode).trim() !== '') {
      params.projectCode = String(projectCode).trim();
    }
    if (siteNo != null && siteNo !== '' && !Number.isNaN(Number(siteNo))) {
      params.siteNo = String(siteNo);
    }
    const response = await api.get(`/users/role/${encodeURIComponent(role)}`, { params });
    return response.data;
  },
};

export default userService;

